import { IAdditionalData } from '@shared/model/basic-data';
import { createReducer, on } from '@ngrx/store';
import { getAdditionalDataSuccess, updateAdditionalDataSuccess } from '../actions';

const initialState: IAdditionalData = {
  contract: undefined,
  contract_date: undefined,
  country: undefined,
  full_name_person_responsible: undefined,
  init_date: undefined,
  name_full: undefined,
  user_code: undefined,
};

export const additionalDataReducer = createReducer(
  initialState,
  on(getAdditionalDataSuccess, (state, { additionalData }) => additionalData),
  on(updateAdditionalDataSuccess, (state, { data }) => ({ ...state, [data.name]: data.value })),
);
